import React, { useState } from 'react'
import { createUserAppointment } from '../../../../Adaptor/TUBSIS/controllers/Appointments/Appointments';
import { Button, Col, FloatingLabel, Form, FormControl, Modal, Row } from 'react-bootstrap';
import moment from 'moment';
import '../../../../style.css'

type Props = { propAppointmentStartDate: Date | null }

const AppointmentCreateWithNotExistUser: React.FC<Props> = ({ propAppointmentStartDate }) => {
    interface FormData {
        expertId: number;
        firstName: string;
        lastName: string;
        tcKimlikNo: string;
        birthDate: Date | null;
        appointmentStartDate: Date | null;
        appointmentEndDate: Date | null;
        isFirstAppointment: boolean;
    }

    const initialFormData: FormData = {
        expertId: 0,
        firstName: '',
        lastName: '',
        tcKimlikNo: '',
        birthDate: null,
        appointmentStartDate: null,
        appointmentEndDate: null,
        isFirstAppointment: true
    };

    const [formData, setFormData] = useState<FormData>(initialFormData);
    const [showModal, setShowModal] = useState(false);
    const [isAppointmentStartDateReadOnly, setIsAppointmentStartDateReadOnly] = useState<boolean>(false);

    const clearForm = () => {
        setSelectedExpertId(null)
        setPhoneNumber(null)
        setEmail(null)
        setFirstName(null)
        setLastName(null)
        setTcKimlikNo(null)
        setBirthDate(null)
        setAppointmentStartDate(null)
        setAppointmentEndDate(null)

        //console.log("date", propAppointmentStartDate)
        if (propAppointmentStartDate && propAppointmentStartDate !== null) {
            const editedPropAppointmentStartDate = new Date(propAppointmentStartDate)

            setAppointmentStartDate(new Date(editedPropAppointmentStartDate))

            let propAppointmentEndDate = new Date(editedPropAppointmentStartDate)
            propAppointmentEndDate.setMinutes(propAppointmentEndDate.getMinutes() + 15)//randevu süresi 15 dk

            setAppointmentEndDate(new Date(propAppointmentEndDate))

            // console.log("date", propAppointmentStartDate, appointmentEndDate)

            setIsAppointmentStartDateReadOnly(true)
        } else {
            setAppointmentStartDate(null)
            setAppointmentEndDate(null)
        }
    }

    const openModal = () => {
        setFormData(initialFormData)
        clearForm()
        setShowModal(true);
    };

    const closeModal = () => {
        clearForm()
        setShowModal(false);
        //window.location.reload();
    };

    const [selectedExpertId, setSelectedExpertId] = useState<number | null>(null);
    const [phoneNumber, setPhoneNumber] = useState<string | null>(null);
    const [email, setEmail] = useState<string | null>(null);
    const [name, setFirstName] = useState<string | null>(null);
    const [surname, setLastName] = useState<string | null>(null);
    const [tcKimlikNo, setTcKimlikNo] = useState<string | null>(null);
    const [birthDate, setBirthDate] = useState<Date | null>(null);
    const [appointmentStartDate, setAppointmentStartDate] = useState<Date | null>(null);
    const [isFirstAppointment, setIsFirstAppointment] = useState<boolean>(true);

    const [appointmentEndDate, setAppointmentEndDate] = useState<Date | null>(null);
    // Uzman seçimi yapıldığında bu fonksiyon çalışacak
    const handleExpertChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const expertId = parseInt(e.target.value);
        if (expertId && expertId > 0) {
            setSelectedExpertId(expertId);
        }
        else {
            setSelectedExpertId(0);
        }
    };

    const parseBirthDateStringToDate = (dateString: string): Date | null => {
        // Tarih stringinin uygun formatta olup olmadığını kontrol et
        const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
        const match = dateString.match(dateRegex);
        if (!match) return null;

        // Yıl, ay ve gün bilgilerini al
        const year = parseInt(match[1]);
        const month = parseInt(match[2]) - 1; // JavaScript'te aylar 0'dan başlar, bu yüzden 1 çıkarıyoruz.
        const day = parseInt(match[3]);

        if (month < 0 || month > 11 || day < 1 || day > 31) return null;

        const parsedDate = new Date(year, month, day);

        // Oluşturulan tarihin geçerli olup olmadığını kontrol et
        const currentDate = new Date();
        if (parsedDate > currentDate) return null;

        return parsedDate;
    };

    const parseAppointmentDateStringToDate = (dateString: string): Date | null => {
        const dateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;
        const match = dateString.match(dateRegex);
        if (!match) return null;

        const year = parseInt(match[1]);
        const month = parseInt(match[2]) - 1;
        const day = parseInt(match[3]);
        const hour = parseInt(match[4]);
        const minute = parseInt(match[5]);

        const parsedDate = new Date(year, month, day, hour, minute);

        // Oluşturulan tarihin geçerli olup olmadığını kontrol et
        const currentDate = new Date();
        if (parsedDate <= currentDate) return null;

        return parsedDate;
    };

    const [isValidPhoneNumber, setIsValidPhoneNumber] = useState<boolean>(true);
    // const [isValidEmail, setIsValidEmail] = useState<boolean>(true);
    const [isValidTcKimlikNo, setIsValidTcKimlikNo] = useState<boolean>(true);
    const [isValidFirstName, setIsValidFirstName] = useState<boolean>(true);
    const [isValidLastName, setIsValidLastName] = useState<boolean>(true);
    const [isValidBirthdate, setIsValidBirthdate] = useState<boolean>(true);
    const [isValidStartDate, setIsValidStartDate] = useState<boolean>(true);
    const [isValidEndDate, setIsValidEndDate] = useState<boolean>(true);

    const handleItemChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, checked, type } = e.target;
        if (name === 'firstName') {
            setFirstName(value);
            setIsValidFirstName(value.trim() !== '');
        } else if (name === 'lastName') {
            setLastName(value);
            setIsValidLastName(value.trim() !== '');
        } else if (name === 'birthDate') {
            const parsedDate = parseBirthDateStringToDate(value);
            setBirthDate(parsedDate);
            setIsValidBirthdate(parsedDate !== null);
        } else if (name === 'appointmentStartDate') {
            const parsedDate = parseAppointmentDateStringToDate(value)
            setAppointmentStartDate(parsedDate);
            setIsValidStartDate(parsedDate !== null);
        } else if (name === 'appointmentEndDate') {
            const parsedDate = parseAppointmentDateStringToDate(value)
            setAppointmentEndDate(parsedDate);
            setIsValidEndDate(parsedDate !== null);
        } else if (name === 'tcKimlikNo') {
            setTcKimlikNo(value);
            const pattern = /^\d{11}$/;
            setIsValidTcKimlikNo(pattern.test(value));
        } else if (name === 'email') {
            setEmail(value);
            // const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            // setIsValidEmail(pattern.test(value));
        } else if (name === 'phoneNumber') {
            setPhoneNumber(value);
            const pattern = /^\d{10,20}$/;
            setIsValidPhoneNumber(pattern.test(value));
        }
    };

    // Türkçe karakterlerin dönüşüm haritası
    const turkishToEnglishMap: { [key: string]: string } = {
        'ç': 'c', 'Ç': 'C',
        'ğ': 'g', 'Ğ': 'G',
        'ı': 'i', 'İ': 'I',
        'ö': 'o', 'Ö': 'O',
        'ş': 's', 'Ş': 'S',
        'ü': 'u', 'Ü': 'U'
    };

    const CreateUsername = (firstName: string, lastName: string): string => {
        // Boşlukları kaldır ve küçük harfe dönüştür
        const sanitizedFirstName = firstName.replace(/\s/g, '').toLowerCase();
        const sanitizedLastName = lastName.replace(/\s/g, '').toLowerCase();

        // Türkçe karakterleri dönüştür
        const replaceTurkishChars = (str: string): string => {
            return str.replace(/[çğıöşüÇĞİÖŞÜ]/g, match => turkishToEnglishMap[match] || match);
        };

        const formattedFirstName = replaceTurkishChars(sanitizedFirstName);
        const formattedLastName = replaceTurkishChars(sanitizedLastName);

        // Kullanıcı adını oluştur ve döndür
        return `${formattedFirstName}.${formattedLastName}`;
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement | HTMLButtonElement>) => {
        e.preventDefault();

        // if (selectedExpertId === null || selectedExpertId <= 0 || isNaN(selectedExpertId)) {
        //     // Eğer uzman seçilmemişse, hata mesajı göster
        //     alert("Lütfen bir uzman seçiniz.");
        //     return;
        // }

        console.log("ilk randevu mu", isFirstAppointment)

        const possibleMinuteList: number[] = [0, 15, 30, 45];

        var startHour = appointmentStartDate?.getHours();
        var startMinute = appointmentStartDate?.getMinutes();

        if (!isValidStartDate || appointmentStartDate === null || startHour === null || (startHour ?? 1) < 9 ||
            (startHour ?? 23) > 15 || startHour === 12 || possibleMinuteList.filter(p => p === (startMinute ?? 1)) === null) {
            alert("Randevu saatleri 9:00 - 11:45 ve 13:00 - 15:45 arasındadır. Her randevu 15 dk sürmektedir. Lütfen uygun bir giriş yapınız.")
            return;
        }

        if (!isValidTcKimlikNo || /*!isValidEmail ||*/ !isValidBirthdate || !isValidFirstName || !isValidLastName ||
            !isValidPhoneNumber || !isValidStartDate || /*!isValidEndDate ||*/ tcKimlikNo === null || /*email === null ||*/
            birthDate === null || name === null || surname === null || phoneNumber === null || appointmentStartDate === null /*|| 
            appointmentEndDate === null*/ ) {
            //console.log("Bir problem var", appointmentEndDate)
            return;
        }

        let parsedAppointmentStartDate = new Date(appointmentStartDate)
        let parsedAppointmentEndDate = new Date(appointmentStartDate)
        let parsedBirthDate = new Date(birthDate)

        parsedAppointmentEndDate.setMinutes(parsedAppointmentEndDate.getMinutes() + 15)//randevu süresi 15 dk

        parsedAppointmentStartDate.setHours(parsedAppointmentStartDate.getHours() + 3)//utc kaynaklı düzeltme
        parsedAppointmentEndDate.setHours(parsedAppointmentEndDate.getHours() + 3)
        parsedBirthDate.setHours(parsedBirthDate.getHours() + 3)

        // console.log("email",email, CreateUsername(name, surname))

        const requestModel = {
            CitizenId: parseInt(tcKimlikNo),
            BirthDate: new Date(parsedBirthDate),
            Name: name,
            Surname: surname,
            FullName: name + ' ' + surname,
            Email: (email && email !== null && email.length !== 0) ? email : CreateUsername(name, surname),
            MobilePhones: phoneNumber,
            AppointmentStartDate: new Date(parsedAppointmentStartDate),
            AppointmentEndDate: new Date(parsedAppointmentEndDate),
            ExpertId: 2,
            GroupId: 6,
            IsFirstAppointment: isFirstAppointment ?? true
        };

        const response = await createUserAppointment(requestModel);

        if (response.success) {
            alert(response.message);
            window.location.reload();
        } else {
            alert(response.message);
            return;
        }

        // Burada form verilerini göndermek için bir fonksiyon çağrılabilir veya başka bir işlem yapılabilir
        closeModal(); // Modalı kapat
    };

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsFirstAppointment(event.target.id === 'isFirstAppointment'); // Radio buton id'sine göre true veya false setleme
    };

    {
        return (
            //<div>AppointmentCreateWithUser</div>
            <div className='text-end mt-2' >
                <input type='button' className='btn btn-primary' value={"OLUŞTUR"} onClick={openModal} />
                <Modal show={showModal} onHide={closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Danışan ve Randevu Oluştur</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleSubmit}>
                            {/* <FloatingLabel className='mb-3' controlId="expertId" key={-1} label="Uzman Seçiniz">
                            <Form.Select name="expertId" onChange={handleExpertChange}>
                                <option value="">Uzman Seçiniz</option>
                                {experts.map(expert => (
                                    <option key={expert.userId} value={expert.userId}>
                                        {expert.fullName}
                                    </option>
                                ))}
                            </Form.Select>
                        </FloatingLabel> */}

                            <Row className="mb-3">
                                <Form.Group as={Col}>
                                    <FloatingLabel controlId="firstName" label="Ad">
                                        <FormControl
                                            type="text"
                                            name="firstName"
                                            isInvalid={!isValidFirstName}
                                            onChange={handleItemChange} />
                                        <Form.Control.Feedback type="invalid">
                                            Lütfen ad girin.
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                </Form.Group>
                                <Form.Group as={Col}>
                                    <FloatingLabel controlId="lastName" label="Soyad">
                                        <FormControl
                                            type="text"
                                            name="lastName"
                                            isInvalid={!isValidLastName}
                                            onChange={handleItemChange} />
                                        <Form.Control.Feedback type="invalid">
                                            Lütfen soyad girin.
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                </Form.Group>
                            </Row>

                            <Row className="mb-3">
                                <Form.Group as={Col}>
                                    <FloatingLabel controlId="tcKimlikNo" label="TC Kimlik No">
                                        <FormControl
                                            type="text"
                                            name="tcKimlikNo"
                                            inputMode="numeric"
                                            required
                                            isInvalid={!isValidTcKimlikNo}
                                            onChange={handleItemChange} />
                                        <Form.Control.Feedback type="invalid">
                                            Geçerli bir TC Kimlik No girin.
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                </Form.Group>
                                <Form.Group as={Col}>
                                    <FloatingLabel controlId="birthDate" label="Doğum Tarihi">
                                        <FormControl
                                            type="date"
                                            name="birthDate"
                                            isInvalid={!isValidBirthdate}
                                            onChange={handleItemChange} />
                                        <Form.Control.Feedback type="invalid">
                                            Lütfen geçerli bir doğum tarihi girin.
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                </Form.Group>
                            </Row>

                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="email">
                                    <FloatingLabel label="Email">
                                        <FormControl
                                            type="email"
                                            name="email"
                                            required
                                            // isInvalid={!isValidEmail}
                                            onChange={handleItemChange} />
                                        <Form.Control.Feedback type="invalid">
                                            Geçerli bir email adresi girin.
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                </Form.Group>
                                <Form.Group as={Col} controlId="phoneNumber">
                                    <FloatingLabel label="Telefon Numarası">
                                        <FormControl
                                            type="tel"
                                            name="phoneNumber"
                                            inputMode="numeric"
                                            required
                                            isInvalid={!isValidPhoneNumber}
                                            onChange={handleItemChange} />
                                        <Form.Control.Feedback type="invalid">
                                            Geçerli bir telefon numarası girin.
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                </Form.Group>
                            </Row>

                            {/* <Row className="mb-3">
                            <Form.Group as={Col}> */}
                            <FloatingLabel controlId="appointmentStartDate" label="Randevu Başlangıç Tarihi">
                                <FormControl
                                    type="datetime-local"
                                    name="appointmentStartDate"
                                    isInvalid={!isValidStartDate}
                                    value={moment(appointmentStartDate).format('YYYY-MM-DDTHH:mm')}
                                    readOnly={isAppointmentStartDateReadOnly}
                                    onChange={handleItemChange} />
                                <Form.Control.Feedback type="invalid">
                                    Geçerli bir tarih ve saat girin.
                                </Form.Control.Feedback>
                            </FloatingLabel>
                            {/* </Form.Group> */}

                            {/* <Form.Group as={Col}>
                                <FloatingLabel controlId="appointmentEndDate" label="Randevu Bitiş Tarihi">
                                    <FormControl 
                                        type="datetime-local" 
                                        name="appointmentEndDate" 
                                        isInvalid={!isValidEndDate}
                                        onChange={handleItemChange} />
                                    <Form.Control.Feedback type="invalid">
                                        Geçerli bir tarih ve saat girin.
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                            </Form.Group>
                        </Row> */}

                            <Row className="mt-5">
                                <Form.Group as={Col}>
                                    <Form.Check
                                        type="radio"
                                        id="isFirstAppointment"
                                        name="flexRadioDefault"
                                        label={<span style={{ fontWeight: 'bold', color: isFirstAppointment ? '#04c8c8' : '#b5b5c3' }}>İLK RANDEVU</span>}
                                        className="form-check-custom form-check-input-xl"
                                        checked={isFirstAppointment}
                                        onChange={handleRadioChange}
                                    />

                                    <Form.Check
                                        type="radio"
                                        id="isNotFirstAppointment"
                                        name="flexRadioDefault"
                                        label={<span style={{ fontWeight: 'bold', color: !isFirstAppointment ? '#04c8c8' : '#b5b5c3' }}>KONTROL RANDEVUSU</span>}
                                        className="form-check-custom mt-2 form-check-input-xl"
                                        checked={!isFirstAppointment}
                                        onChange={handleRadioChange}
                                    />
                                </Form.Group>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeModal}>
                            Kapat
                        </Button>
                        <Button variant="primary" onClick={handleSubmit}>
                            Kaydet
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default (AppointmentCreateWithNotExistUser)